var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
import { recommendedApiInternalComponentTypesPath, importApiInternalComponentTypesPath, allowedAttachableTypesApiInternalComponentTypesPath } from '@routes';
import { mapCreateComponentTypeToApiRequest, mapImportRecommendedComponentTypeToApiRequest, mapUpdateComponentTypeToApiRequest } from './mapper';
// Get all component types
export function getComponentTypes() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/component_types');
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching component types:', error);
            return {
                error: {
                    message: 'Failed to fetch component types'
                }
            };
        }
    });
}
// Create a new component type
export function createComponentType(data) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const requestData = mapCreateComponentTypeToApiRequest(data);
            const response = yield api.post('/api/internal/component_types', requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error creating component type:', error);
            // Extract error messages from API response
            let errorMessage = 'Failed to create component type';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                if (((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) && Array.isArray(axiosError.response.data.errors)) {
                    // Use the first error message from the errors array
                    errorMessage = axiosError.response.data.errors[0] || errorMessage;
                }
                else if ((_d = (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) {
                    errorMessage = axiosError.response.data.error;
                }
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Update an existing component type
export function updateComponentType(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const requestData = mapUpdateComponentTypeToApiRequest(data);
            const response = yield api.patch(`/api/internal/component_types/${id}`, requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error updating component type:', error);
            // Extract error messages from API response
            let errorMessage = 'Failed to update component type';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                if (((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) && Array.isArray(axiosError.response.data.errors)) {
                    // Use the first error message from the errors array
                    errorMessage = axiosError.response.data.errors[0] || errorMessage;
                }
                else if ((_d = (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) {
                    errorMessage = axiosError.response.data.error;
                }
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Toggle active status of a component type (replaces delete functionality)
export function toggleComponentTypeStatus(id) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const response = yield api.delete(`/api/internal/component_types/${id}`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error toggling component type status:', error);
            // Extract error messages from API response
            let errorMessage = 'Failed to toggle component type status';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                if (((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) && Array.isArray(axiosError.response.data.errors)) {
                    // Use the first error message from the errors array
                    errorMessage = axiosError.response.data.errors[0] || errorMessage;
                }
                else if ((_d = (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) {
                    errorMessage = axiosError.response.data.error;
                }
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Get all available categories
export function getCategories() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/component_types/categories');
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching categories:', error);
            return {
                error: {
                    message: 'Failed to fetch categories'
                }
            };
        }
    });
}
// Get all allowed attachable types
export function getAllowedAttachableTypes() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(allowedAttachableTypesApiInternalComponentTypesPath());
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching allowed attachable types:', error);
            return {
                error: {
                    message: 'Failed to fetch allowed attachable types'
                }
            };
        }
    });
}
// Get recommended component types
export function getRecommendedComponentTypes() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(recommendedApiInternalComponentTypesPath());
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching recommended component types:', error);
            return {
                error: {
                    message: 'Failed to fetch recommended component types'
                }
            };
        }
    });
}
// Import the recommended component type
export function importRecommendedComponentType(data) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            const requestData = mapImportRecommendedComponentTypeToApiRequest(data);
            const response = yield api.post(importApiInternalComponentTypesPath(), requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error importing recommended component type:', error);
            // Extract error messages from API response
            let errorMessage = 'Failed to import recommended component type';
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error;
                if (((_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) && Array.isArray(axiosError.response.data.errors)) {
                    // Use the first error message from the errors array
                    errorMessage = axiosError.response.data.errors[0] || errorMessage;
                }
                else if ((_d = (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) {
                    errorMessage = axiosError.response.data.error;
                }
            }
            return {
                error: {
                    message: errorMessage
                }
            };
        }
    });
}
// Export default object with all functions
export default {
    getComponentTypes,
    createComponentType,
    updateComponentType,
    toggleComponentTypeStatus,
    getCategories,
    getAllowedAttachableTypes,
    getRecommendedComponentTypes,
    importRecommendedComponentType
};
